import MathHtml from 'components/imported-assessment/MathHtml'
import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import {isEmpty} from '../../../helpers/utils'
import {findGlobalIndex} from './utils'

import questionHandlers from './question-handlers'

const useStyles = makeStyles(questionStyles)
 
export default function Question ({sections, context}) {

  const {questionId, sectionId, translate, quizQuestionTypes} = context

  const assessmentLoaded = !context.quizSearch['assessment-to-take']

  const classes = useStyles()

  const count = sections.reduce((a, b) => a + b.questions.length, 0)

  const sectionIndex = sections.findIndex(s => s.id == sectionId)
  const section = sectionIndex >= 0 && sections[sectionIndex]

  const questionIndex = questionId && section ? section.questions.findIndex(q => q.id == questionId) : -1
  const question = questionIndex >= 0 && section.questions[questionIndex]

  const {html} = question && question.premise || {}

  const premiseHtml = isEmpty(html) ? false : html

  const type = quizQuestionTypes.find(t => t.id == question.type) || {}

  const title = translate(type.name)

  const globalIndex = findGlobalIndex(question.id, sections)
  const indexLabel = `${translate('questions').substring(0,1)}: ${globalIndex + 1}/${count}`

  const Handler = questionHandlers[type.name]

  const defaultPremiseLabel = `${type.name}-default-premise`
  const defaultPremise = translate(defaultPremiseLabel)
  const hasDefaultPremise = defaultPremiseLabel != defaultPremise

  return (
    <Box key={question.id} className={classes.root}>
      <Box className={classes.header}>
        <Box className={classes.title}>{title}</Box>
        <Box className={classes.index}>{indexLabel}</Box>
      </Box>
      <Box className={classes.content}>
        {premiseHtml && (context.importedMath ? <MathHtml className={classes.premise} html={premiseHtml} /> : <div className={classes.premise} dangerouslySetInnerHTML={{__html: premiseHtml}} />)}
        {!premiseHtml && hasDefaultPremise && <Box className={classes.premise}>{defaultPremise}</Box>}
        <Box className={classes.question}>
          {assessmentLoaded && Handler && <Handler {...{context, question, section, questionIndex}} />}
        </Box>
      </Box>
    </Box>
  )
}



function questionStyles(theme) {

  const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  }

  return {
    root: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      color: '#525b6c',
    },
    header: {
      display: 'flex',
      fontSize: '13pt',
      padding: '10px 20px',
      borderBottom: 'solid 1px #d0d5d8',
    },
    title: {
      flexGrow: 1,
      ...verticalCentering
    },
    index: {
      fontSize: '10pt',
      ...verticalCentering
    },
    content: {
      flexGrow: 1,
      overflowY: 'auto',
      padding: 30,
      display: 'flex',
      flexDirection: 'column',
    },
    premise: {
      fontWeight: 'bold',
      fontSize: '12pt',
      marginBottom: 20,
    },
  }
}
